import React from 'react';
import { columnKeyMap } from '../../../shared/constants/columnKeyMap';
import CellContent from '../../../shared/ui/CellContent/CellContent';
import TransportActionBtns from '../components/TransportActionBtns/TransportActionBtns';
import ClientsContent from '../components/ClientsContent/ClientsContent';
import { Icon } from 'antd';

const {
  brand,
  model,
  region,
  country,
  number,
  clients,
  hasPermits,
  transportType,
} = columnKeyMap;

const widths = {
  number: '10%',
  transportType: '10%',
  region: '10%',
  brand: '10%',
  model: '10%',
  country: '10%',
  permit: '10%',
  clients: '20%',
  actions: '10%',
};

const contentStyle = {
  color: '#3378F9',
  fontWeight: 600,
};

export const getTableColumns = ({ sortedInfo, expandedRowKeys }) => [
  {
    title: 'Госномер',
    key: number,
    dataIndex: number,
    colSpan: 1,
    width: widths.number,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === number && sortedInfo?.order,
    render: (value) => (
      <CellContent
        topRowContent={value?.split(/(?<=\D)(?=\d)|(?<=\d)(?=\D)/).join(' ')}
        isHighlighted
      />
    ),
  },

  {
    title: 'Регион',
    key: region,
    dataIndex: region,
    colSpan: 1,
    width: widths.region,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === region && sortedInfo?.order,
    render: (value) => (
      <CellContent
        topRowContent={value}
        isHighlighted
      />
    ),
  },
  {
    title: 'Тип ТС',
    key: transportType,
    dataIndex: transportType,
    colSpan: 1,
    width: widths.transportType,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === transportType && sortedInfo?.order,
    render: (value) => (
      <CellContent
        topRowContent={value}
        isHighlighted
      />
    ),
  },
  {
    title: 'Марка',
    key: brand,
    dataIndex: brand,
    colSpan: 1,
    width: widths.brand,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === brand && sortedInfo?.order,
    render: (value) => (
      <CellContent
        topRowContent={value}
        isWhite
      />
    ),
  },
  {
    title: 'Модель',
    key: model,
    dataIndex: model,
    colSpan: 1,
    width: widths.model,
    render: (value) => (
      <CellContent
        topRowContent={value}
        isWhite
      />
    ),
  },
  {
    title: 'Страна',
    key: country,
    dataIndex: country,
    colSpan: 1,
    width: widths.country,
    render: (value) => (
      <CellContent
        topRowContent={value}
        isHighlighted
      />
    ),
  },
  {
    title: 'Владельцы',
    key: clients,
    dataIndex: clients,
    colSpan: 1,
    width: widths.clients,
    render: (value, record) => (
      <ClientsContent
        clients={value}
        isExpanded={expandedRowKeys.includes(record.transport.id)}
      />
    ),
  },
  {
    title: 'Пропуска',
    key: hasPermits,
    dataIndex: hasPermits,
    colSpan: 1,
    width: widths.permit,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === hasPermits && sortedInfo?.order,
    render: (value) => (
      <CellContent
        topRowContent={
          value ? <Icon type="check-circle" /> : <Icon type="close-circle" />
        }
        topRowTitle={value ? 'Есть пропуска' : 'Нет пропусков'}
        isWhite
        contentStyle={
          !!value ? { ...contentStyle, fontSize: 20 } : { fontSize: 20 }
        }
      />
    ),
  },
  {
    key: 'requestCount',
    colSpan: 1,
    width: widths.actions,
    render: (_, record) => <TransportActionBtns record={record} />,
  },
];
